import { Button } from '@cian/ui-kit';
import { IconActionCompareAdd16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NEWBUILDING_COMPARE_ENABLED_CONFIG } from '../../../constants/newbuildingCompare';
import { selectActiveTab } from '../../../selectors/activeTab';
import { ETabType } from '../../../types/filters';
import { useApplicationContext } from '../../../utils/applicationContext';

export const NewbuildingCompareMassActionContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const { activeTab } = useSelector(selectActiveTab);
  const isNewbuildingCompareEnabled = config.get<boolean>(NEWBUILDING_COMPARE_ENABLED_CONFIG) || false;

  if (!isNewbuildingCompareEnabled || activeTab !== ETabType.JK) {
    return null;
  }

  return (
    <Button
      beforeIcon={<IconActionCompareAdd16 color="icon-main-default" />}
      size="XS"
      theme="fill_white_primary"
      data-name="NewbuildingCompareMassAction"
    >
      Сравнить
    </Button>
  );
};
